export default __webpack_public_path__ + "static/media/fMaltoBuza27.ca269429.png";